import { IconLinkContainer, H2Menu, H2Menu2 } from '../../assets/styles/menuStyles';
import { Link } from '../../assets/styles/generalStyles';
import { slide as BurgerMenu, State } from 'react-burger-menu';
import { IconLinks } from './IconLinks';
import { useState } from 'react';
import BurgerIcon from '../../assets/icons/burger-menu.svg';
import CrossIcon from '../../assets/icons/arrow-right.svg';
import { PageNames } from '../../assets/ts/customTypes';
import { BsHouseFill } from 'react-icons/bs';
import { determineRisk } from '../../pages/UVpage';

export function Menu({
    setNextPage,
    uvIndex = 0,
    currentPage,
}: {
    setNextPage: (nextPage: PageNames) => void;
    uvIndex?: number;
    currentPage: PageNames;
}) {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const handleClick = (nextPage: PageNames) => {
        if (nextPage !== PageNames.INDEX) {
            window.scrollTo({ top: 0 });
        }
        setIsMenuOpen(false);
        setNextPage(nextPage);
    };
    const handleStateChange = (state: State) => {
        setIsMenuOpen(state.isOpen);
    };
    const uvColor = determineRisk(uvIndex).color;
    const getMenuText = (pageName: PageNames) => {
        switch (pageName) {
            case PageNames.INDEX:
                return 'UV-Index: Tagesspitzenwert';
            case PageNames.LOCATIONS:
                return 'Standort auswählen';
            case PageNames.DETAILS:
                return 'UV-Index: Aktueller Wert';
            case PageNames.CAMPAIGN:
                return 'Die Kampagne';
            case PageNames.TAN:
                return 'Wissenswertes';
            case PageNames.TIPS:
                return 'Richtiger UV-Schutz';
            case PageNames.SPONSORS:
                return 'Partner & Sponsoren';
            case PageNames.IMPRINT:
                return 'Impressum & Datenschutz';
        }
    };
    return (
        <BurgerMenu
            customBurgerIcon={<img src={BurgerIcon} alt='Open Menu' />}
            customCrossIcon={<img src={CrossIcon} alt='Close Menu' />}
            isOpen={isMenuOpen}
            onStateChange={handleStateChange}
            right={true}
            width={'75%'}
        >
            <H2Menu>MEHR</H2Menu>
            <H2Menu2>ERFAHREN:</H2Menu2>
            {Object.values(PageNames).map((pageName) => (
                <Link
                    uvColor={currentPage === pageName ? uvColor : 'inherit'}
                    onClick={() => handleClick(pageName)}
                    key={pageName}
                >
                    {pageName === PageNames.INDEX && <BsHouseFill style={{ marginRight: '0.5rem' }} />}
                    {getMenuText(pageName)}
                </Link>
            ))}
            <div>
                <IconLinkContainer>
                    <IconLinks socialMedia='Instagram' />
                    <IconLinks socialMedia='Facebook' />
                </IconLinkContainer>
            </div>
        </BurgerMenu>
    );
}
